<div class="actions">
  <button nz-button nzType="primary" (click)="add()">{{resolveKey("AddTranslation") | translate}}</button>
</div>
